export interface GridGuideGrid {
  args?: {
    nl?: boolean;
    w?: number;
    h?: number;
    [key: string]: unknown;
  };
  gridWidth?: number;
  gridHeight?: number;
  width?: number;
  height?: number;
}

export interface GridGuideArrowVisibility {
  left: boolean;
  right: boolean;
  up: boolean;
  down: boolean;
}

export const getGridGuideArrowVisibility = (
  grid?: GridGuideGrid
): GridGuideArrowVisibility => {
  if (!grid?.args?.nl) {
    return {
      left: true,
      right: true,
      up: true,
      down: true,
    };
  }

  const width = grid.gridWidth ?? grid.width ?? grid.args.w ?? 0;
  const height = grid.gridHeight ?? grid.height ?? grid.args.h ?? 0;
  const isVerticalNumberLine = height > width;

  return {
    left: !isVerticalNumberLine,
    right: !isVerticalNumberLine,
    up: isVerticalNumberLine,
    down: isVerticalNumberLine,
  };
};
